import { FeRecordType } from "config/config";
import {
    advancedSearchFilterStorageKey,
    StoredFilterState,
    writeStoredFilter,
} from "containers/ExecutionFilter/filterStorage";
import { executionsTab, messagesTab, resourcesTab } from "containers/AdvancedSearch/constants";
import { ActivityType } from "graphql/generated/graphql";
import { mapScreensToPaths } from "utils/RouterManager/utils";
import { activityList, getFilterFieldsList, getFilterString, getSearchObj } from "utils/utils";

type AdvancedSearchTab = typeof resourcesTab | typeof executionsTab | typeof messagesTab;

const getAdvancedSearchTab = (recordType: string): AdvancedSearchTab => {
    const upperType = recordType.toUpperCase();
    if (upperType === "MESSAGE") {
        return messagesTab;
    }
    if (activityList.includes(upperType as ActivityType)) {
        return executionsTab;
    }
    return resourcesTab;
};

const serializeWidgetFilter = (filter: unknown): string | undefined => {
    if (filter == null) {
        return undefined;
    }
    return typeof filter === "string" ? filter : JSON.stringify(filter);
};

/**
 * Seed advanced-search filter state for a dashboard record-list widget and return its path.
 *
 * Resource types open the Resources tab with `resource_type` set; activity types open
 * Executions or Messages. The widget filter is applied as `customFilter`.
 */
export const buildRecordListAdvancedSearchPath = (
    recordType: FeRecordType | string,
    filter?: unknown
): string => {
    const upperType = recordType.toUpperCase();
    const tab = getAdvancedSearchTab(upperType);

    const stored: StoredFilterState = {
        include_deleted: false,
        hide_deleted: true,
        tab,
    };

    if (tab === resourcesTab) {
        stored.filter = getFilterString(
            getFilterFieldsList(
                getSearchObj({
                    value: [upperType],
                    field: "resource_type",
                    op: "in",
                })
            )
        );
    }

    const customFilter = serializeWidgetFilter(filter);
    if (customFilter) {
        stored.customFilter = customFilter;
    }

    writeStoredFilter(advancedSearchFilterStorageKey, stored);
    return mapScreensToPaths.advancedSearch;
};
